// src/components/texting/TextThreadModal.jsx
// Modal wrapper around TextThread for the pipeline drawers (LogActivityModal
// pattern: fixed overlay + centered card + navy header).
import React from "react";
import { X, MessageSquare } from "lucide-react";
import TextThread from "./TextThread";

export default function TextThreadModal({
  leadId,
  dealId,
  contactId,
  contactIds,
  contactName,
  initialBody,
  onClose,
}) {
  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-[60]" onClick={onClose} />
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="w-full max-w-md h-[80vh] bg-white rounded-xl shadow-2xl flex flex-col overflow-hidden pointer-events-auto">
          <div className="bg-[#1E293B] text-white px-5 py-4 flex items-center justify-between">
            <div className="text-base font-bold flex items-center gap-2">
              <MessageSquare size={16} /> Texts
              {contactName ? ` · ${contactName}` : ""}
            </div>
            <button
              onClick={onClose}
              className="p-1 text-slate-300 hover:text-white"
            >
              <X size={18} />
            </button>
          </div>
          <div className="flex-1 p-4 overflow-hidden">
            <TextThread
              leadId={leadId}
              dealId={dealId}
              contactId={contactId}
              contactIds={contactIds}
              contactName={contactName}
              initialBody={initialBody}
            />
          </div>
        </div>
      </div>
    </>
  );
}
